/* THIS FILE IS GENERATED ON RUNTIME. DO NOT EDIT */

module.exports = { 
  typography: ["headline-2xl","headline-xl","headline-lg","headline-md","headline-sm","headline-xs","special-headline-lg","special-headline-sm","quote-lg","quote-md","preamble-md","paragraph-md","body-lg","body-md","body-sm","button-md","button-sm","category-md"],
  prose: ["factbox","coverbox","author-details","newsletter-signup-modal"],
};